import { useGet } from 'ccstate-react'
import { page$ } from './infra/router/currentPage'

export default function CurrentPage() {
  return useGet(page$)
}